import { EPointType } from "../types"
import { POINT_TYPE_ICON } from "./pointTypeIcon"

export const POINT_TYPE_HINT: {
    [key in keyof typeof POINT_TYPE_ICON]?: string
} = {
    [EPointType.Water]: 'Water - Liquid that freezes at 0°C and boils at 100°C',
    [EPointType.Sand]: 'Sand - Basic particle affected by gravity, melts at 1700°C',
    [EPointType.Stone]: 'Stone - Solid that melts into lava above 1300°C',
    [EPointType.Lava]: 'Lava - Hot liquid that solidifies below 1200°C',
    [EPointType.Metal]: 'Metal - Conducts electricity and melts above 1500°C',
    [EPointType.Electricity_Ground]: 'Electricity Ground - Absorbs electrical charge',
    [EPointType.Electricity_Spark]: 'Electricity Spark - Moves chaotically and conducts electricity',
    [EPointType.Electricity_Source]: 'Electricity Source - Generates electrical charge',
    [EPointType.Electricity_Amplifier]: 'Electricity Amplifier - Multiplies electrical charge',
    [EPointType.Heater]: 'Heater - Consumes electricity to generate heat',
    [EPointType.Cooler]: 'Cooler - Consumes electricity to absorb heat',
    [EPointType.ColdDetector]: 'Cold Detector - Emits electricity when temperature falls below -50°C',
    [EPointType.HotDetector]: 'Hot Detector - Emits electricity when temperature rises above 90°C',
    [EPointType.LiquidDetector]: 'Liquid Detector - Emits electricity when in contact with liquids',
    [EPointType.Wood]: 'Wood - Burns at temperatures above 300°C',
    [EPointType.Border]: 'Border - Immovable boundary element',
    [EPointType.Fire]: 'Fire - Short-lived hot element that burns nearby materials',
    [EPointType.IceFire]: 'Ice Fire - Cold fire that freezes nearby materials',
    [EPointType.Bomb]: 'Bomb - Explodes on contact',
    [EPointType.Dynamite]: 'Dynamite - Stationary explosive',
    [EPointType.Ice]: 'Ice - Solid water that melts at 0°C',
    [EPointType.Clone]: 'Clone - Copies adjacent elements',
    [EPointType.Gas]: 'Gas - Light particle that moves chaotically and ignites above 400°C',
    [EPointType.Void]: 'Void - Removes any element it touches',
    [EPointType.ConstantCold]: 'Constant Cold - Permanently emits extreme cold',
    [EPointType.ConstantHot]: 'Constant Hot - Permanently emits extreme heat',
    [EPointType.LiquidGas]: 'Liquid Gas - Cold liquid that evaporates at -160°C',
    [EPointType.LiquidGlass]: 'Liquid Glass - Molten glass that solidifies below 1300°C',
    [EPointType.Glass]: 'Glass - Transparent solid material that melts at 1400°C',
    [EPointType.Virus]: 'Virus - Infects and transforms adjacent elements',
    [EPointType.Heal]: 'Heal - Neutralizes viruses and restores infected elements',
    [EPointType.Acid]: 'Acid - Corrosive liquid that dissolves various materials',
    [EPointType.PlantSeed]: 'Plant Seed - Grows into a plant when given the right conditions',
    [EPointType.Wire]: 'Wire - Creates a direct electrical connection between two points',
    [EPointType.Pipe]: 'Pipe - Creates a direct path for liquids to flow between two points',
    [EPointType.Snow]: 'Snow - Light particles that melt into water when heated above 0°C',
    [EPointType.Magnet]: 'Magnet - Dark-gray powder that is attracted to metal objects',
    [EPointType.WindSource]: 'Wind Source - Creates air currents that push lighter elements',
    [EPointType.Ant]: 'Ant - A small creature that moves around and can carry small objects',
    [EPointType.FireAnt]: 'Fire Ant - A fiery version of ant that moves around and can carry small objects',
    [EPointType.IceAnt]: 'Ice Ant - A freezing version of ant that moves around and can carry small objects',
    [EPointType.Worm]: 'Worm - A burrowing creature that moves through blocks',
    [EPointType.Smoke]: 'Smoke - Light particles that rise and dissipate over time',
    [EPointType.Oil]: 'Oil - Flammable liquid that burns at high temperatures',
    [EPointType.Steam]: 'Steam - Water vapor that rises and cools into water',
    [EPointType.MoltenMetal]: 'Molten Metal - Hot liquid metal that solidifies below 1500°C',
    [EPointType.Mirror]: 'Mirror - Reflects light rays',
    [EPointType.LightSource]: 'Light Source - Emits light in all directions',
    [EPointType.LightDetector]: 'Light Detector - Generates electricity when exposed to light',
    [EPointType.LightBulb]: 'Light Bulb - Consumes electricity to emit light, brightness depends on charge',
    eraser: 'Eraser - Removes elements from the simulation',
    heatTool: 'Heat Tool - Increases temperature of elements',
    coolTool: 'Cool Tool - Decreases temperature of elements',
} 